// 【 持久化存储的仓库 】模块
const persistedStateStore = {
  state: {
    // 是否同时具有 多版本报告权限 和 已应用报告权限
    isHasAndUseMultiReportVersion: null,
    isUseMultiReportTypes: {},
    hasReportMultiVersionPermission: false,
  },
  getters: {
    getIsHasAndUseMultiReportVersion(state) {
      return (reportType) => {
        if (!state.hasReportMultiVersionPermission) return false
        return state.isUseMultiReportTypes[reportType]
      }
    },
  },
  mutations: {
    setIsHasAndUseMultiReportVersion(state, config) {
      state.isUseMultiReportTypes = config.isUseMultiReportTypes
      state.hasReportMultiVersionPermission = config.hasReportMultiVersionPermission
    },
  },
}
export default persistedStateStore
